import React from 'react'
import {
    FormattedMessage,
    AppId
} from 'base-app'

import {
    ACTION_GET_PARTNER_LIST,
    CALL_BACK_TOGGLE_NHAN_BAN_CUNG,
    CALL_BACK_TOGGLE_TT_NGUOIBAN,
    CALL_BACK_TOGGLE_EXPRESS,
    CALL_BACK_RECEIPT_INSURANCE,
    CALL_BACK_METHOD_INTERNET_BANKING,
    CALL_BACK_METHOD_VISA_CARD,
    CALL_BACK_METHOD_ATM,
    CALL_BACK_METHOD_QR,
    CALL_BACK_AGREE_PAYMENT,
    ACTION_CREATE_CONSTRACT,
    ACTION_UPDATE_ACTIVE_STEP,
    ACTION_CREATE_NEW_OWNER,
    ACTION_IS_LOADING,
    ACTION_IS_CAl_FEE,
    ACTION_GET_USER_INFO,
    ACTION_GET_ROLE
} from '../actions/buyInsuranceCar'

import * as BuyInsuranceConst from '../../configs/constants/BuyInsurance';

const initialState = {
    titleWizardCar: [<FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.VehicleInfo`} />,
    <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.InsuranceContent`} />,
    <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.OwnAcctInfo`} />,
    <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.ReceiptAdd`} />,
    <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.Payment`} />,
    <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.Complete`} />],
    partners: [],
    roles: [],
    userinfo: null,
    agreePayment: false,
    validateStep1: false,

    activeStep: 0,
    constractId: '',
    isLoading: false,
    isCalFee: false,

    step1Data: {
        init: {
        }

    },
    step2Data: {
    },
    step3Data: {

    },
    step5Data: {
        init: {
            toggleNhanBanCung: false,
            toggleNhanTTTuNguoiBan: false,
            toggleExpress: false
        },
        receiptInsuranceNum: "",
        paymentMethod: "",
        toogleAgreePayment: false
    },
    step6Data: {
        init: {

        },
        receiptInsuranceNum: "",
        paymentMethod: "",
        toogleAgreePayment: false
    }
}

const buyInsuranceCarReducer = (state = initialState, action) => {
    // console.log(`buyInsuranceCarReducer:`, action.type + " " + action.payload);
    switch (action.type) {
        case "RESET":
            return initialState

        case ACTION_GET_PARTNER_LIST:
            return {
                ...state,
                partners: action.payload

            }
        case ACTION_GET_ROLE:
            return {
                ...state,
                roles: action.payload

            }
        case ACTION_GET_USER_INFO:
            return {
                ...state,
                userinfo: action.payload

            }
        case ACTION_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload

            }
        case ACTION_IS_CAl_FEE:
            return {
                ...state,
                isCalFee: action.payload

            }
        case ACTION_CREATE_NEW_OWNER:
            return {
                ...state,
                step3Data: {
                    ...state.step3Data,
                    isCreateOwner: action.payload

                }
            }
        case ACTION_UPDATE_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload

            }
        case ACTION_CREATE_CONSTRACT:
            return {
                ...state,
                constractId: action.payload

            }
        case CALL_BACK_TOGGLE_NHAN_BAN_CUNG:
            let toggleNhanTTTuNguoiBan = false;
            let toggleExpress = false;
            if (action.payload) {
                toggleNhanTTTuNguoiBan = state.step5Data.init.toggleNhanTTTuNguoiBan;
                toggleExpress = state.step5Data.init.toggleExpress;
            } else {
                toggleNhanTTTuNguoiBan = false;
                toggleExpress = false;
            }
            return {
                ...state,
                step5Data: {
                    ...state.step5Data,
                    init: {
                        ...state.step5Data.init,
                        toggleNhanBanCung: action.payload,
                        toggleNhanTTTuNguoiBan: toggleNhanTTTuNguoiBan,
                        toggleExpress: toggleExpress
                    }
                }
            }
        case CALL_BACK_TOGGLE_TT_NGUOIBAN:
            toggleExpress = false;
            if (action.payload) {
                toggleExpress = false;
            } else {
                toggleExpress = state.step5Data.init.toggleExpress;
            }
            return {
                ...state,
                step5Data: {
                    ...state.step5Data,
                    init: {
                        ...state.step5Data.init,
                        toggleNhanTTTuNguoiBan: action.payload,
                        toggleExpress: toggleExpress
                    }
                }
            }
        case CALL_BACK_TOGGLE_EXPRESS:
            toggleNhanTTTuNguoiBan = false;
            if (action.payload) {
                toggleNhanTTTuNguoiBan = false;
            } else {
                toggleNhanTTTuNguoiBan = state.step5Data.init.toggleNhanTTTuNguoiBan;
            }
            return {
                ...state,
                step5Data: {
                    ...state.step5Data,
                    init: {
                        ...state.step5Data.init,
                        toggleNhanTTTuNguoiBan: toggleNhanTTTuNguoiBan,
                        toggleExpress: action.payload
                    }
                }
            }
        case CALL_BACK_RECEIPT_INSURANCE:
            return {
                ...state,
                step5Data: {
                    ...state.step5Data,
                    receiptInsuranceNum: action.payload
                }
            }
        case CALL_BACK_METHOD_INTERNET_BANKING:
        case CALL_BACK_METHOD_VISA_CARD:
        case CALL_BACK_METHOD_ATM:
        case CALL_BACK_METHOD_QR:
            return {
                ...state,
                step5Data: {
                    ...state.step5Data,
                    paymentMethod: action.payload
                }
            }
        case CALL_BACK_AGREE_PAYMENT:
            return {
                ...state,
                step5Data: {
                    ...state.step5Data,
                    toogleAgreePayment: action.payload
                }
            }
        default:
            return state
    }
}

export default buyInsuranceCarReducer
